import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
  static targets = ['select', 'email', 'phone']

  fill() {
    const option = this.selectTarget.selectedOptions[0]
    this.emailTarget.value = (option && option.dataset.email) || ''
    this.phoneTarget.value = (option && option.dataset.phone) || ''
  }
}
